(function () {
  "use strict";

  /*
   * Enter your Klaviyo Public Site ID here.
   * Do not use a private API key.
   */
  const KLAVIYO_COMPANY_ID = "UEnQkh";

  const MODAL_ID = "quick-view-back-in-stock-modal";
  const STYLE_ID = "quick-view-back-in-stock-styles";

    function addStyles() {
  if (document.getElementById(STYLE_ID)) {
    return;
  }

  const style = document.createElement("style");

  style.id = STYLE_ID;

  style.textContent = `
  
    quick-view-back-in-stock {
      display: block;
      width: 100%;
      margin-top: 10px;
    }

    quick-view-back-in-stock[hidden] {
      display: none !important;
    }

    quick-view-back-in-stock [data-back-in-stock-button] {
      width: 100%;
    }

    body.qv-bis-modal-open {
      overflow: hidden;
    }

    #${MODAL_ID},
    #${MODAL_ID} *,
    #${MODAL_ID} *::before,
    #${MODAL_ID} *::after {
      box-sizing: border-box;
    }

    #${MODAL_ID} {
      position: fixed;
      inset: 0;
      z-index: 2147483647;
      display: none;
      overflow-x: hidden;
      overflow-y: auto;
      outline: 0;
      background: rgba(0, 0, 0, 0.65);
      color: #111111;
      font-family: TwentiethCentury, sans-serif;
      font-size: 14px;
      line-height: 1.5;
      -webkit-overflow-scrolling: touch;
      -webkit-font-smoothing: antialiased;
    }
      #${MODAL_ID} * { 
      font-family: TwentiethCentury, sans-serif !important;
}

    #${MODAL_ID}.is-open {
      display: block;
    }

    #${MODAL_ID} .qv-bis-dialog {
      position: relative;
      width: 100%;
      min-height: 100%;
      margin: 0 auto;
      padding: 12px 18px 40px;
      overflow: hidden;
      background: #ffffff;
      color: #111111;
      font-family: TwentiethCentury, sans-serif;
      font-size: 14px;
      line-height: 1.5;
      pointer-events: auto !important;
    }

    #${MODAL_ID} .qv-bis-title {
      margin: 0 35px 10px 0;
      color: inherit;
      font-family: TwentiethCentury, sans-serif;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.5;
    }

    #${MODAL_ID} .qv-bis-description {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 1.5;
    }

    #${MODAL_ID} .qv-bis-close {
      position: absolute;
      top: 7px;
      right: 15px;
      z-index: 10;
      width: auto;
      height: auto;
      padding: 0;
      overflow: visible;
      border: 0;
      background: transparent;
      color: #c51c26;
      font-family: inherit;
      font-size: 30px;
      font-weight: 700;
      line-height: 1;
      text-shadow: 0 1px 0 #ffffff;
      cursor: pointer;
      pointer-events: auto !important;
      -webkit-appearance: none;
      appearance: none;
    }

    #${MODAL_ID} .qv-bis-close:hover,
    #${MODAL_ID} .qv-bis-close:focus {
      color: #c51c26;
      opacity: 0.8;
      outline: none;
    }

    #${MODAL_ID} [data-qv-bis-form] {
      margin: 0;
    }

    #${MODAL_ID} .qv-bis-field {
      position: relative;
      z-index: 2;
      display: block;
      width: 100%;
      height: 46px;
      margin: 0 0 15px;
      padding: 10px 16px;
      border: 1px solid #cccccc;
      border-radius: 2px;
      background-color: #ffffff;
      background-image: none;
      color: #222222;
      font-family: inherit;
      font-size: 14px;
      line-height: 1.3333333;
      outline: none;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
      transition:
        border-color ease-in-out 0.15s,
        box-shadow ease-in-out 0.15s;
      pointer-events: auto !important;
    }

    #${MODAL_ID} .qv-bis-field:focus {
      border-color: #888888;
      outline: 0;
      box-shadow:
        inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(102, 175, 233, 0.6);
    }

    #${MODAL_ID} select.qv-bis-field {
      cursor: pointer;
      text-transform: none;
    }

    #${MODAL_ID} input.qv-bis-field {
      line-height: normal;
      cursor: text;
      user-select: text;
    }

    #${MODAL_ID} .qv-bis-submit {
      display: inline-block;
      width: 100%;
      min-height: 54px;
      margin-top: 5px;
      margin-bottom: 0;
      padding: 14px;
      border: 1px solid #c51c26;
      border-radius: 2px;
      background-color: #c51c26;
      background-image: none;
      color: #ffffff;
      font-family: inherit;
      font-size: 15px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      cursor: pointer;
      touch-action: manipulation;
      user-select: none;
      pointer-events: auto !important;
      -webkit-appearance: button;
      appearance: button;
    }

    #${MODAL_ID} .qv-bis-submit:hover,
    #${MODAL_ID} .qv-bis-submit:focus {
      color: #ffffff;
      background-color: #c51c26;
      border-color: #c51c26;
      opacity: 0.9;
      outline: none;
    }

    #${MODAL_ID} .qv-bis-submit:disabled {
      opacity: 0.6;
      cursor: wait;
    }

    #${MODAL_ID} .qv-bis-message {
      display: none;
      margin: 15px 0 0;
      padding: 6px 11px;
      border: 1px solid transparent;
      border-radius: 2px;
      font-size: 13px;
      line-height: 1.5;
    }

    #${MODAL_ID} .qv-bis-message.is-error {
      display: block;
      border-color: #fcd6d7;
      background-color: #fcd6d7;
      color: #c72e2f;
    }

    #${MODAL_ID} .qv-bis-message.is-success {
      display: block;
      border-color: #d3efcd;
      background-color: #d3efcd;
      color: #111111;
    }

    @media only screen and (min-width: 500px) {
      #${MODAL_ID} .qv-bis-dialog {
        max-width: 460px;
        min-height: auto;
        padding: 30px 40px;
        border-radius: 3px;
      }
    }

    @media only screen and (min-width: 992px) {
      #${MODAL_ID} .qv-bis-dialog {
        margin-top: 100px;
      }
    }
  `;

  document.head.appendChild(style);

  }

  function createModal() {
    let modal = document.getElementById(MODAL_ID);

    if (modal) {
      return modal;
    }

    modal = document.createElement("div");

    modal.id = MODAL_ID;
    modal.setAttribute("aria-hidden", "true");

    modal.innerHTML = `
      <div
        class="qv-bis-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qv-bis-title"
      >
        <button
          type="button"
          class="qv-bis-close"
          data-qv-bis-close
          aria-label="Close popup"
        >
          &times;
        </button>

        <h3
          id="qv-bis-title"
          class="qv-bis-title"
          data-qv-bis-title
        >
          Notify me
        </h3>

        <p class="qv-bis-description">
          Register to receive a notification when this item comes back in stock.
        </p>

        <form data-qv-bis-form novalidate>
          <select
            class="qv-bis-field"
            data-qv-bis-variant
            aria-label="Select unavailable option"
            required
          ></select>

          <input
            type="email"
            class="qv-bis-field"
            data-qv-bis-email
            placeholder="Email"
            aria-label="Email"
            autocomplete="email"
            required
            name="email"
          >

          <button
            type="submit"
            class="qv-bis-submit"
            data-qv-bis-submit
          >
            Notify me when in stock
          </button>

          <div
            class="qv-bis-message"
            data-qv-bis-message
            role="status"
            aria-live="polite"
          ></div>
        </form>
      </div>
    `;

    document.body.appendChild(modal);

    const dialog = modal.querySelector(
      ".qv-bis-dialog"
    );

    const closeButton = modal.querySelector(
      "[data-qv-bis-close]"
    );

    const emailInput = modal.querySelector(
      "[data-qv-bis-email]"
    );

    const variantSelect = modal.querySelector(
      "[data-qv-bis-variant]"
    );

    const form = modal.querySelector(
      "[data-qv-bis-form]"
    );

    /*
     * Direct listener ensures the cross works even though
     * dialog events are stopped from bubbling.
     */
    closeButton.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        event.stopPropagation();

        closeModal();
      }
    );

    /*
     * Prevent the Stiletto Quick View handlers from
     * intercepting interactions inside this popup.
     *
     * Do not call preventDefault here.
     */
    [
      "pointerdown",
      "mousedown",
      "touchstart",
      "click"
    ].forEach(function (eventName) {
      dialog.addEventListener(
        eventName,
        function (event) {
          event.stopPropagation();
        }
      );
    });

    emailInput.addEventListener(
      "click",
      function (event) {
        event.stopPropagation();
        emailInput.focus();
      }
    );

    variantSelect.addEventListener(
      "click",
      function (event) {
        event.stopPropagation();
      }
    );

    /*
     * Clicking the dark background closes the popup.
     */
    modal.addEventListener(
      "click",
      function (event) {
        if (event.target === modal) {
          closeModal();
        }
      }
    );

    form.addEventListener(
      "submit",
      handleSubmit
    );

    return modal;
  }

  function getUnavailableVariants(component) {
    const rawVariants =
      component.dataset.unavailableVariants || "[]";

    try {
      const variants = JSON.parse(rawVariants);

      if (!Array.isArray(variants)) {
        return [];
      }

      return variants
        .filter(function (variant) {
          return variant && variant.id;
        })
        .map(function (variant) {
          return {
            id: String(variant.id),
            title:
              variant.title ||
              "Unavailable option"
          };
        });
    } catch (error) {
      console.error(
        "[Quick View BIS] Invalid unavailable variants JSON",
        {
          value: rawVariants,
          error: error,
          component: component
        }
      );

      return [];
    }
  }

  function populateVariantDropdown(component) {
    const modal = createModal();

    const variantSelect = modal.querySelector(
      "[data-qv-bis-variant]"
    );

    const unavailableVariants =
      getUnavailableVariants(component);

    const currentVariantId = String(
      component.dataset.variantId || ""
    );

    const currentVariantTitle =
      component.dataset.variantTitle || "";

    variantSelect.innerHTML = "";

    /*
     * Fallback when the Liquid list is missing.
     */
    if (
      unavailableVariants.length === 0 &&
      currentVariantId
    ) {
      unavailableVariants.push({
        id: currentVariantId,
        title:
          currentVariantTitle ||
          "Selected option"
      });
    }

    unavailableVariants.forEach(
      function (variant) {
        const option =
          document.createElement("option");

        option.value = String(variant.id);
        option.textContent = variant.title;

        if (
          String(variant.id) ===
          currentVariantId
        ) {
          option.selected = true;
        }

        variantSelect.appendChild(option);
      }
    );

    const hasCurrentVariant =
      Array.from(
        variantSelect.options
      ).some(function (option) {
        return (
          option.value === currentVariantId
        );
      });

    if (
      !hasCurrentVariant &&
      variantSelect.options.length
    ) {
      variantSelect.selectedIndex = 0;
    }

    variantSelect.disabled =
      variantSelect.options.length === 0;

    console.log(
      "[Quick View BIS] Variant dropdown populated",
      {
        unavailableVariants:
          unavailableVariants,
        currentVariantId:
          currentVariantId,
        selectedVariantId:
          variantSelect.value
      }
    );
  }

  function showMessage(type, text) {
    const modal = createModal();

    const message = modal.querySelector(
      "[data-qv-bis-message]"
    );

    message.className = "qv-bis-message";
    message.textContent = "";

    if (!type || !text) {
      return;
    }

    message.classList.add(
      "is-" + type
    );

    message.textContent = text;
  }

  function openModal(component) {
    const modal = createModal();

    /*
     * Move the popup into Stiletto's Quick View modal
     * so its fields remain inside the theme focus trap.
     */
    const quickViewModal = component.closest(
      "[data-quick-view-modal]"
    );

    if (
      quickViewModal &&
      modal.parentElement !== quickViewModal
    ) {
      quickViewModal.appendChild(modal);
    }

    const titleElement = modal.querySelector(
      "[data-qv-bis-title]"
    );

    const emailInput = modal.querySelector(
      "[data-qv-bis-email]"
    );

    const submitButton = modal.querySelector(
      "[data-qv-bis-submit]"
    );

    const productTitle =
      component.dataset.productTitle ||
      "Notify me";

    titleElement.textContent =
      productTitle;

    populateVariantDropdown(component);

    emailInput.value = "";

    emailInput.removeAttribute("disabled");
    emailInput.removeAttribute("readonly");
    emailInput.removeAttribute("inert");

    submitButton.disabled = false;
    submitButton.textContent =
      "Notify me when in stock";

    showMessage("", "");

    modal.classList.add("is-open");
    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.classList.add(
      "qv-bis-modal-open"
    );

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        emailInput.focus();
      });
    });

    console.log(
      "[Quick View BIS] Popup opened",
      {
        productTitle: productTitle,
        currentVariantId:
          component.dataset.variantId,
        unavailableVariants:
          getUnavailableVariants(component),
        quickViewModal: quickViewModal
      }
    );
  }

  function closeModal() {
    const modal =
      document.getElementById(MODAL_ID);

    if (!modal) {
      return;
    }

    const focusedElement =
      modal.querySelector(":focus");

    if (focusedElement) {
      focusedElement.blur();
    }

    modal.classList.remove("is-open");

    modal.setAttribute(
      "aria-hidden",
      "true"
    );

    document.body.classList.remove(
      "qv-bis-modal-open"
    );

    console.log(
      "[Quick View BIS] Popup closed"
    );
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email
    );
  }

  async function subscribeToKlaviyo(
    email,
    variantId
  ) {
    if (!KLAVIYO_COMPANY_ID) {
      throw new Error(
        "The Klaviyo public Site ID has not been configured."
      );
    }

    if (!email) {
      throw new Error(
        "The email address is missing."
      );
    }

    if (!variantId) {
      throw new Error(
        "The selected variant ID is missing."
      );
    }

    const endpoint =
      "https://a.klaviyo.com/client/back-in-stock-subscriptions" +
      "?company_id=" +
      encodeURIComponent(
        KLAVIYO_COMPANY_ID
      );

    const payload = {
      data: {
        type:
          "back-in-stock-subscription",

        attributes: {
          profile: {
            data: {
              type: "profile",

              attributes: {
                email: email
              }
            }
          },

          channels: ["EMAIL"]
        },

        relationships: {
          variant: {
            data: {
              type:
                "catalog-variant",

              id:
                "$shopify:::$default:::" +
                String(variantId)
            }
          }
        }
      }
    };

    console.log(
      "[Quick View BIS] Sending Klaviyo request",
      {
        endpoint: endpoint,
        email: email,
        variantId: variantId,
        catalogVariantId:
          payload.data.relationships.variant.data.id
      }
    );

    const response = await fetch(
      endpoint,
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",
          "Accept":
            "application/json",
          "revision":
            "2026-07-15"
        },

        body: JSON.stringify(payload)
      }
    );

    if (response.status === 202) {
      console.log(
        "[Quick View BIS] Subscription accepted",
        {
          email: email,
          variantId: variantId
        }
      );

      return true;
    }

    let responseData = null;
    let responseText = "";

    try {
      responseText =
        await response.text();

      if (responseText) {
        responseData =
          JSON.parse(responseText);
      }
    } catch (error) {
      console.warn(
        "[Quick View BIS] Could not parse Klaviyo response",
        error
      );
    }

    console.error(
      "[Quick View BIS] Klaviyo request rejected",
      {
        status: response.status,
        statusText:
          response.statusText,
        response:
          responseData ||
          responseText
      }
    );

    let errorMessage =
      "Unable to subscribe. Please try again.";

    if (
      responseData &&
      Array.isArray(
        responseData.errors
      ) &&
      responseData.errors.length
    ) {
      errorMessage =
        responseData.errors[0].detail ||
        responseData.errors[0].title ||
        errorMessage;
    }

    throw new Error(errorMessage);
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;

    const emailInput = form.querySelector(
      "[data-qv-bis-email]"
    );

    const variantSelect = form.querySelector(
      "[data-qv-bis-variant]"
    );

    const submitButton = form.querySelector(
      "[data-qv-bis-submit]"
    );

    const email =
      emailInput.value.trim();

    const variantId =
      variantSelect.value.trim();

    if (!isValidEmail(email)) {
      showMessage(
        "error",
        "Please enter a valid email address."
      );

      emailInput.focus();

      return;
    }

    if (!variantId) {
      showMessage(
        "error",
        "Please select an unavailable option."
      );

      variantSelect.focus();

      return;
    }

    submitButton.disabled = true;
    submitButton.textContent =
      "Submitting...";

    showMessage("", "");

    try {
      await subscribeToKlaviyo(
        email,
        variantId
      );

      submitButton.textContent =
        "Subscribed";

      showMessage(
        "success",
        "You're in! We'll let you know when this item is back in stock."
      );
    } catch (error) {
      console.error(
        "[Quick View BIS] Subscription failed",
        error
      );

      submitButton.disabled = false;

      submitButton.textContent =
        "Notify me when in stock";

      showMessage(
        "error",
        error.message ||
          "Unable to subscribe. Please try again."
      );
    }
  }

  class QuickViewBackInStock extends HTMLElement {
    constructor() {
      super();

      this.handleButtonClick =
        this.handleButtonClick.bind(this);
    }

    connectedCallback() {
      if (
        this.dataset.initialized ===
        "true"
      ) {
        return;
      }

      this.dataset.initialized =
        "true";

      this.button = this.querySelector(
        "[data-back-in-stock-button]"
      );

      if (!this.button) {
        console.warn(
          "[Quick View BIS] Button not found",
          this
        );

        return;
      }

      this.button.addEventListener(
        "click",
        this.handleButtonClick
      );

      console.log(
        "[Quick View BIS] Component connected",
        {
          component: this,
          variantId:
            this.dataset.variantId,
          variantTitle:
            this.dataset.variantTitle,
          unavailableVariants:
            getUnavailableVariants(this)
        }
      );
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener(
          "click",
          this.handleButtonClick
        );
      }

      this.dataset.initialized =
        "false";
    }

    handleButtonClick(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      console.log(
        "[Quick View BIS] Button clicked",
        this
      );

      openModal(this);
    }

    updateVariant(variant) {
      if (!variant) {
        return;
      }

      this.dataset.variantId =
        String(variant.id);

      this.dataset.variantTitle =
        variant.public_title ||
        variant.title ||
        "";

      /*
       * Display Notify only when the currently
       * selected variant is unavailable.
       */
      this.hidden =
        Boolean(variant.available);

      /*
       * Keep the dropdown synchronized if the
       * popup is currently open.
       */
      const modal =
        document.getElementById(
          MODAL_ID
        );

      if (
        modal &&
        modal.classList.contains(
          "is-open"
        )
      ) {
        const variantSelect =
          modal.querySelector(
            "[data-qv-bis-variant]"
          );

        const variantId =
          String(variant.id);

        const matchingOption =
          Array.from(
            variantSelect.options
          ).find(function (option) {
            return (
              option.value ===
              variantId
            );
          });

        if (matchingOption) {
          variantSelect.value =
            variantId;
        }
      }

      console.log(
        "[Quick View BIS] Variant updated",
        {
          id: variant.id,
          title: variant.title,
          available:
            variant.available
        }
      );
    }
  }

  addStyles();
  createModal();

  if (
    !customElements.get(
      "quick-view-back-in-stock"
    )
  ) {
    customElements.define(
      "quick-view-back-in-stock",
      QuickViewBackInStock
    );
  }

  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key === "Escape") {
        closeModal();
      }
    }
  );

  console.log(
    "[Quick View BIS] Web component registered"
  );
})();